module.exports = __webpack_public_path__ + "static/media/cloud1.8410b88f.png";